var cdn = {
  url: 'https://cdn.sporkbytes.com'
};
var confirmationWindowLengthInHours = {
  client: 48,
  partner: 24
};
var deliveryGracePeriodInMinutes = 10;
var emailAddresses = {
  help: 'eat@sporkbytes.com',
  order: 'eat@sporkbytes.com'
};
var phoneNumber = '5038217709';
var phoneNumbers = {
  billing: "".concat(phoneNumber, ",3"),
  dispatch: "".concat(phoneNumber, ",9"),
  generalInquiries: "".concat(phoneNumber, ",4"),
  main: phoneNumber,
  orderHelp: "".concat(phoneNumber, ",1"),
  partners: "".concat(phoneNumber, ",2")
};
var postDeliveryEditWindowInDays = 3;
var postDeliveryEditWindowInHours = postDeliveryEditWindowInDays * 24;
var reviewableMealsTimeframe = {
  amount: 1,
  scale: 'week'
};
var shortLinkDomain = 'https://sporkbyt.es';

export { cdn, confirmationWindowLengthInHours, deliveryGracePeriodInMinutes, emailAddresses, phoneNumbers, postDeliveryEditWindowInDays, postDeliveryEditWindowInHours, reviewableMealsTimeframe, shortLinkDomain };
